<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

        <material-card

          :title="$t('projectTypes.edit.title')"
          :text="$t('projectTypes.edit.text')"

        >

          <v-form @submit.prevent="editProjectType">
            <v-container >
              <v-row>


                <v-col
                  cols="12"
                  md="6"
                  >
                  <v-text-field
                    v-model="name"
                    :label="$t('projectType.name')"

                    :error-messages="nameErrors"
                    required
                    @input="$v.name.$touch()"
                    @blur="$v.name.$touch()"

                  />
                </v-col>

                <v-col>

                  <v-combobox
                    v-model="workTypes"
                    :items="allWorkTypes"
                    :item-text="'name'"
                    :item-value="'id'"
                    chips
                    multiple
                    :label="$t('projectTypes.edit.selectWorkTypes')"
                  ></v-combobox>
                </v-col>


                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn   @click.prevent="historyBack">
                    {{$t("global.cancel")}}
                  </v-btn>&nbsp;
                  <v-btn @click="submit" color="success">
                    {{$t("global.save")}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import { required, maxLength } from 'vuelidate/lib/validators'


    export default {
        data() {
            return {
              id:"",
                name:"",
                workTypes : [],
                allWorkTypes: [],
              projectTypes: []
            }
        },
        validations: {
            name: {
                required,
                maxLength:maxLength(255),
              isUnique(value) {
                if (value === '') return true
                let currentId = -this.id
                let existingItems = this.projectTypes.filter(function (ele) {
                  return ele.name ==value && ele.id != currentId
                })
                return existingItems.length == 0
              }
            }
        },
        methods: {
            submit () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.editProjectType()
                }
            },
          getProjectTypes () {
            api.getProjectTypes().then(response => {
              this.projectTypes = response
              //   console.log(response.data)
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })
          },
            getProjectType(projectTypeId) {
                api.getProjectType(projectTypeId).then(response => {
                    this.id = response.id
                    this.name= response.name
                    this.workTypes = response.workTypes
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getWorkTypes() {
                api.getWorkTypes().then(response => {
                    this.allWorkTypes = response
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            editProjectType() {
                var workTypeIds = []
                var workTypeNames = []
                workTypeIds =  this.workTypes.filter(workType => typeof workType =='object').map(workType => workType.id);
                workTypeNames =  this.workTypes.filter(workType => typeof workType =='string');

                 api.editProjectType(this.id, this.name, workTypeIds, workTypeNames).then(response => {
                    this.$router.push({path: '/projectTypes'});
                    //   console.log(response.data)
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })


            }

        },
        computed: {


            nameErrors () {
                const errors = []
                if (!this.$v.name.$dirty) return errors
                !this.$v.name.maxLength && errors.push(this.$t('validation.maxLength', [this.$t('projectType.name'), 255]))
                !this.$v.name.required && errors.push(this.$t('validation.required', [this.$t('projectType.name')]))
              !this.$v.name.isUnique && errors.push(this.$t('validation.unique', [this.$t('projectType.name')]))

              return errors
            }
        },
        mounted() {
            this.getProjectType(this.$route.params.id)
            this.getWorkTypes()
            this.getProjectTypes()
        }
    }
</script>
